module.exports = __webpack_public_path__ + "img/expression6.a7d94d6c.png";